module.exports = __webpack_public_path__ + "img/hard-cornering.39bc010b.png";